import React, {Component} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

import Firebase from 'src/Firebase'



class AddGenericToAssociationDialog extends Component {


    static defaultProps = {
        headerColor: 'black',
        bodyColor: 'black',
    };

    constructor(props) {
        super(props);

        this.state = {
            value: this.props.defaultValue,
            open: false,
            popRef: null,
            sortAscending: false,
            sortDescending: false,
            notificationType: '',
            notificationHeader: '',
            notificationBody: '',
            idTarget: '',
        }

        this.topRef = null
    }

    componentDidMount() {
        //alert(this.props.defaultValue)
    }

    tryConfirm() {

      this.setState({
        dialogWorking: true
      })
      let suc = (x) => {
        this.setState({
          dialogWorking: false
        })
        if (x == 0) {
          alert('Could not find ' + this.props.itemLowerCase + ' with this ID.')
        } else if (x == 1) {
          alert(this.props.item + ' added to association!')
        } else if (x == -1) {
          alert('This ' + this.props.itemLowerCase + ' already belons to an association. Please remove it from the other association before adding it to this one.')
        }
      }
      let fail = () => {
        this.setState({
          dialogWorking: false
        })
        alert('An error occurred. Check your connection and try again.')
      }
      Firebase.addGenericToAssociation({'targetId': this.state.idTarget, 'associationId': this.props.associationId,
    'itemMappingTarget': this.props.itemMappingTarget, 'associationMappingTarget': this.props.associationMappingTarget}, suc, fail)
    }

   

    render() {
        return (
            <Dialog
            open={this.props.open}
            onClose={() => this.props.onClose()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{this.props.alertTitle}</DialogTitle>
            <DialogContent>
                
              <DialogContentText id="alert-dialog-description">
                {this.state.dialogWorking ? 'Performing Operation...' : this.props.alertBody}
                {this.state.dialogWorking ? <div style={{alignItems: 'center', justifyContent: 'center'}}><CircularProgress/></div> : <div/>}
              </DialogContentText>
  
       <TextField
            autoFocus
            margin="dense"
            id="idTarget"
            label={this.props.promptLabel}
            fullWidth
            value={this.state.idTarget}
            onChange={(e) => {
              this.setState({
                idTarget: e.target.value
              })
            }}
          />

            </DialogContent>
            <DialogActions>
              <Button onClick={() => this.props.onClose()} color="primary">
                {this.props.alertCancelText}
              </Button>
              <Button onClick={() => this.tryConfirm()} color="primary" autoFocus>
                {this.props.alertConfirmText}
              </Button>
            </DialogActions>
          </Dialog>
        )

    }
}
const headerStyle = {
    backgroundColor: 'rgb(67,67,67)', flexWrap: 'never', whiteSpace: 'noWrap'
}

/*   <div onClick={() => this.adjustSortDescending()} style={{ margin: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: this.state.sortDescending ? 'orange' : 'white', border: this.state.sortDescending ? '' : '1px solid black', borderRadius: 30, padding: 0, height: 30, padding: 5 }}>
                                <p>Descending</p>
                            </div>*/

/*
 * 
 * 
 *             */

export default AddGenericToAssociationDialog;